import PolicyLastUpdated from "./PolicyLastUpdated";

export default PolicyLastUpdated;
